import { qs, qsa } from "@fluorescent/dom";
import { focusFormStatus } from "@/js/lib/a11y";

import { section } from "@/js/glow";
import { wrapIframes, wrapTables } from "@/js/lib/rte";
import SocialShare from "@/js/lib/social-share";
import { animateArticle, shouldAnimate } from "@/js/lib/animation";
import Carousel from "@/js/lib/carousel";

const selectors = {
  featuredProducts: ".js-featured-products-article"
};

section("article", {
  onLoad() {
    focusFormStatus(this.container);

    const socialShareContainer = qs(".social-share", this.container);

    if (socialShareContainer) {
      this.socialShare = SocialShare(socialShareContainer);
    }

    wrapIframes(qsa("iframe", this.container));
    wrapTables(qsa("table", this.container));

    if (shouldAnimate(this.container)) {
      this.animateArticle = animateArticle(this.container);
    }

    this._initCarousel()
  },

  _initCarousel() {
    this.featuredProducts = qsa(selectors.featuredProducts, this.container);
    if (!this.featuredProducts) return
    this.carousel = Carousel(this.container, {
      slidesPerView: 1.5,
      spaceBetween: 10,
      breakpoints: {
        720: {
          spaceBetween: 10,
          slidesPerView: 2.36
        }
      }
    });
  },

  onUnload() {
    this.socialShare && this.socialShare();
    this.animateArticle?.destroy();
    this.carousel?.destroy();
  },
});
